var _rect, _path, _path2, _path3, _path4, _path5, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 239,
    viewBox: "0 0 170 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169.71,
    height: 239,
    rx: 8,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.139 112.5V106.389C100.139 105.878 100.035 105.372 99.8323 104.901C99.6298 104.429 99.333 104 98.9588 103.639C98.5847 103.278 98.1405 102.991 97.6516 102.796C97.1627 102.601 96.6388 102.5 96.1096 102.5H73.5802C72.5115 102.5 71.4866 102.91 70.731 103.639C69.9753 104.368 69.5508 105.357 69.5508 106.389V133.611C69.5508 134.643 69.9753 135.632 70.731 136.361C71.4866 137.09 72.5115 137.5 73.5802 137.5H79.7469",
    stroke: "#C2C2C2",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1953 111.25H92.4894",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1953 117.5H92.4894",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1953 123.75H87.3914",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.449 126.752L96.8913 136.135L89.9414 137.5L91.3319 130.677L100.889 121.294C101.247 120.901 101.682 120.585 102.169 120.363C102.655 120.14 103.182 120.018 103.719 120.002C104.255 119.986 104.789 120.077 105.288 120.27C105.787 120.463 106.241 120.753 106.622 121.123C107.005 121.495 107.305 121.94 107.505 122.43C107.704 122.921 107.799 123.447 107.783 123.975C107.766 124.503 107.64 125.022 107.41 125.499C107.181 125.977 106.853 126.404 106.449 126.752Z",
    stroke: "#C2C2C2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.25,
    x2: 10.7111,
    y2: -1.25,
    transform: "matrix(0.713938 0.700209 -0.713938 0.700209 97.5898 122.5)",
    stroke: "#C2C2C2",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4);
export default __webpack_public_path__ + "static/media/A4.413ea8c6c7021de04b713b788efea4c1.svg";
export { ForwardRef as ReactComponent };